// extracted by mini-css-extract-plugin
export default {"settings":"UWNKN","label":"iygrx","divider":"iKGyR","preview":"Ekxw5","percentToComplete":"MedYI"};